module.exports = __webpack_public_path__ + "img/homepage-quick-links-lincoln.06bf5a03.jpg";